import { c as _c } from "react/compiler-runtime";
import { triggerActionLocoKeys, triggerDescriptionLocoKeys } from 'modules/automation-rules/triggers/constants/trigger-loco-keys';
import { AutomationRuleTriggersDataEnum, AutomationRuleTriggersEnum } from 'modules/automation-rules/triggers/enums/trigger-enum';
import { TriggersDataInterface, useTriggersData } from 'modules/automation-rules/triggers/hooks/use-triggers-data';
import { AutomationRulesTriggersEditType } from 'modules/automation-rules/triggers/types/automation-rule-triggers-edit-interface';
import { getTriggerIcon } from 'modules/automation-rules/triggers/utils/get-trigger-icon';
import React, { type JSX } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { CloseIcon } from '@systemeio/ui/icons';
export interface WrapperChildrenPropsInterface {
  renderTriggerLabel: ({
    label,
    additionalLabel
  }: {
    label: string;
    additionalLabel?: JSX.Element;
  }) => JSX.Element;
  onOpen: (slug: AutomationRuleTriggersDataEnum) => void;
  onClear: (slug: AutomationRuleTriggersDataEnum) => void;
  data: TriggersDataInterface;
}
type ChildrenType = (args: WrapperChildrenPropsInterface) => JSX.Element;
interface RuleTriggerWrapperProps {
  trigger: AutomationRulesTriggersEditType;
  children: ChildrenType;
  onDelete: () => void;
}
const RuleTriggerWrapper = t0 => {
  const $ = _c(53);
  const {
    trigger,
    children,
    onDelete
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const blogId = trigger.type === AutomationRuleTriggersEnum.blog_page_form_subscribed ? trigger.blog.id : undefined;
  const blogEntity = trigger.type === AutomationRuleTriggersEnum.blog_page_form_subscribed ? trigger.page.type : undefined;
  const formSubscribeFunnelId = trigger.type === AutomationRuleTriggersEnum.form_subscribed ? trigger.funnelStep.funnel.id : undefined;
  const newSaleFunnelId = trigger.type === AutomationRuleTriggersEnum.new_sale ? trigger.funnelStep.funnel.id : undefined;
  const cancelSaleFunnelId = trigger.type === AutomationRuleTriggersEnum.sale_canceled ? trigger.funnelStep.funnel.id : undefined;
  const pageVisitedFunnelId = trigger.type === AutomationRuleTriggersEnum.page_visited ? trigger.funnelStep.funnel.id : undefined;
  const webinarFunnelId = trigger.type === AutomationRuleTriggersEnum.registered_to_webinar ? trigger.webinar.registrationFunnelStep.funnel.id : undefined;
  const triggerCourseId = trigger.type === AutomationRuleTriggersEnum.module_completed || trigger.type === AutomationRuleTriggersEnum.lecture_completed ? trigger.course.id : undefined;
  const triggerModuleId = trigger.type === AutomationRuleTriggersEnum.lecture_completed ? trigger.module?.id : undefined;
  const subscriptionFailedFunnelId = trigger.type === AutomationRuleTriggersEnum.subscription_payment_failed ? trigger.funnelStep.funnel.id : undefined;
  const triggerMailingId = trigger.type === AutomationRuleTriggersEnum.email_link_clicked ? trigger.mailing.id : undefined;
  const triggerDigitalStoreId = trigger.type === AutomationRuleTriggersEnum.digital_store_form_subscribed ? trigger.digitalStore.id : undefined;
  const triggerWebsiteId = trigger.type === AutomationRuleTriggersEnum.website_form_subscribed ? trigger.website.id : undefined;
  const triggerWebsitePageId = trigger.type === AutomationRuleTriggersEnum.website_form_subscribed ? trigger.website.websitePage?.pageContentId : undefined;
  let t1;
  if ($[0] !== blogEntity || $[1] !== blogId || $[2] !== cancelSaleFunnelId || $[3] !== formSubscribeFunnelId || $[4] !== newSaleFunnelId || $[5] !== pageVisitedFunnelId || $[6] !== subscriptionFailedFunnelId || $[7] !== trigger.type || $[8] !== triggerCourseId || $[9] !== triggerDigitalStoreId || $[10] !== triggerMailingId || $[11] !== triggerModuleId || $[12] !== triggerWebsiteId || $[13] !== triggerWebsitePageId || $[14] !== webinarFunnelId) {
    t1 = {
      trigger: trigger.type,
      blogId,
      formSubscribeFunnelId,
      newSaleFunnelId,
      cancelSaleFunnelId,
      pageVisitedFunnelId,
      blogEntity,
      webinarFunnelId,
      triggerCourseId,
      triggerModuleId,
      triggerMailingId,
      subscriptionFailedFunnelId,
      triggerDigitalStoreId,
      triggerWebsiteId,
      triggerWebsitePageId
    };
    $[0] = blogEntity;
    $[1] = blogId;
    $[2] = cancelSaleFunnelId;
    $[3] = formSubscribeFunnelId;
    $[4] = newSaleFunnelId;
    $[5] = pageVisitedFunnelId;
    $[6] = subscriptionFailedFunnelId;
    $[7] = trigger.type;
    $[8] = triggerCourseId;
    $[9] = triggerDigitalStoreId;
    $[10] = triggerMailingId;
    $[11] = triggerModuleId;
    $[12] = triggerWebsiteId;
    $[13] = triggerWebsitePageId;
    $[14] = webinarFunnelId;
    $[15] = t1;
  } else {
    t1 = $[15];
  }
  const {
    triggersData,
    setShouldFetch
  } = useTriggersData(t1);
  const renderTriggerLabel = _temp;
  let t2;
  if ($[16] !== trigger.type) {
    t2 = getTriggerIcon(trigger.type);
    $[16] = trigger.type;
    $[17] = t2;
  } else {
    t2 = $[17];
  }
  let t3;
  if ($[18] !== t2) {
    t3 = <div className="[&>svg]:h-[40x] [&>svg]:w-[40px] w-[40px]">{t2}</div>;
    $[18] = t2;
    $[19] = t3;
  } else {
    t3 = $[19];
  }
  const t4 = triggerActionLocoKeys[trigger.type];
  let t5;
  if ($[20] !== t || $[21] !== t4) {
    t5 = t(t4);
    $[20] = t;
    $[21] = t4;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  let t6;
  if ($[23] !== t5) {
    t6 = <span className="text-text-primary text-[15px] font-bold">{t5}</span>;
    $[23] = t5;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  const t7 = triggerDescriptionLocoKeys[trigger.type];
  let t8;
  if ($[25] !== t || $[26] !== t7) {
    t8 = t(t7);
    $[25] = t;
    $[26] = t7;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  let t9;
  if ($[28] !== t8) {
    t9 = <span>{t8}</span>;
    $[28] = t8;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== t6 || $[31] !== t9) {
    t10 = <div className="flex flex-col gap-1">{t6}{t9}</div>;
    $[30] = t6;
    $[31] = t9;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  let t11;
  if ($[33] !== t10 || $[34] !== t3) {
    t11 = <div className="flex gap-3">{t3}{t10}</div>;
    $[33] = t10;
    $[34] = t3;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  let t12;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <CloseIcon className="main-transition-colors fill-fill-primary group-hover:fill-text-primary group-focus-visible:fill-text-primary" />;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  let t13;
  if ($[37] !== onDelete) {
    t13 = <button onClick={onDelete} className="group h-fit outline-hidden">{t12}</button>;
    $[37] = onDelete;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  let t14;
  if ($[39] !== t11 || $[40] !== t13) {
    t14 = <div className="flex justify-between gap-3">{t11}{t13}</div>;
    $[39] = t11;
    $[40] = t13;
    $[41] = t14;
  } else {
    t14 = $[41];
  }
  let t15;
  let t16;
  if ($[42] !== setShouldFetch) {
    t15 = slug => setShouldFetch(prev => ({
      ...prev,
      [slug]: true
    }));
    t16 = slug_0 => setShouldFetch(prev_0 => ({
      ...prev_0,
      [slug_0]: false
    }));
    $[42] = setShouldFetch;
    $[43] = t15;
    $[44] = t16;
  } else {
    t15 = $[43];
    t16 = $[44];
  }
  let t17;
  if ($[45] !== children || $[46] !== t15 || $[47] !== t16 || $[48] !== triggersData) {
    t17 = children({
      data: triggersData,
      onOpen: t15,
      onClear: t16,
      renderTriggerLabel
    });
    $[45] = children;
    $[46] = t15;
    $[47] = t16;
    $[48] = triggersData;
    $[49] = t17;
  } else {
    t17 = $[49];
  }
  let t18;
  if ($[50] !== t14 || $[51] !== t17) {
    t18 = <div className="flex flex-col gap-3">{t14}{t17}</div>;
    $[50] = t14;
    $[51] = t17;
    $[52] = t18;
  } else {
    t18 = $[52];
  }
  return t18;
};
export default RuleTriggerWrapper;
function _temp(t0) {
  const {
    label,
    additionalLabel
  } = t0;
  return <div className="flex gap-1.5"><div className="flex gap-0.5 text-sm font-medium"><span>{label}</span><span className="text-danger">*</span></div>{additionalLabel}</div>;
}